import withStep from '@/containers/withStep';

import ForcedVatId from './variants/ForcedVatId';
import OptionalVatId from './variants/OptionalVatId';
import OptionalVatRegistrationDefault from './variants/OptionalVatRegistrationDefault';
import { CONFIGURATION_KEY } from './constants';

export const VARIANTS = [ForcedVatId, OptionalVatId, OptionalVatRegistrationDefault];

export default withStep('VatId', {
  id: 'vat-id',
  description: 'Collects the tax registration number',
  configurationKey: CONFIGURATION_KEY,
  variants: VARIANTS,
});
